/**
 * Türkiye telefon numarası: yazarken biçimlendirme, denetleme, saklama.
 *
 * Görünüş `(532) 123 45 67`, alan kodu parantezde, devamı 3-2-2; Türkiye'de
 * numara böyle söylenir ve böyle yazılır. Saklanan `+905321234567`.
 *
 * Kabul: 10 hane, 2-5 ile başlayan (5 cep, 2/3/4 sabit hat alan kodları).
 * Baştaki 0 ya da +90, boşluk, tire, parantez, yapıştırılan her biçim
 * temizlenip aynı 10 haneye iniyor.
 */

/** The 10 national digits, however the number was typed or pasted. */
export function phoneDigits(input: string): string {
  let d = input.replace(/\D/g, '')
  if (d.startsWith('90') && d.length > 10) d = d.slice(2)
  if (d.startsWith('0')) d = d.slice(1)
  return d.slice(0, 10)
}

/** `(532) 123 45 67`, built up as far as the digits go. */
export function formatPhone(input: string): string {
  const d = phoneDigits(input)
  if (d.length === 0) return ''
  const a = d.slice(0, 3)
  const b = d.slice(3, 6)
  const c = d.slice(6, 8)
  const e = d.slice(8, 10)
  let out = d.length <= 3 ? `(${a}` : `(${a}) ${b}`
  if (c) out += ` ${c}`
  if (e) out += ` ${e}`
  return out
}

/** What is wrong with the number, or null when it is a valid one. */
export function phoneProblem(input: string): string | null {
  const d = phoneDigits(input)
  if (d.length === 0) return 'Telefon numarası gerekli.'
  if (!/^[2-5]/.test(d)) return 'Numara alan koduyla başlamalı: 5xx ya da 2xx, 3xx, 4xx.'
  if (d.length < 10) return 'Numara eksik: alan kodu ve 7 hane.'
  return null
}

/** The stored form, `+90` and the 10 digits. Call only on a valid number. */
export function phoneE164(input: string): string {
  return `+90${phoneDigits(input)}`
}
